import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useErrorBoundaryStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalXXL,
    textAlign: 'center',
  },
  title: {
    fontSize: fontScale.heading,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  message: {
    fontSize: fontScale.subtitle,
    color: tokens.colorNeutralForeground2,
    maxWidth: '30rem',
  },
});
